/** Shared order search normalization + client match (M Orders board). */
export function normalizeOrderSearch(raw) {
  return (raw || "").trim().replace(/^#+/, "");
}

/** When to hit the API — keeps 1-digit order #; text needs 2+ chars. */
export function shouldCommitOrderSearch(query) {
  const q = normalizeOrderSearch(query);
  if (!q) return true;
  if (/^\d+$/.test(q)) return true;
  return q.length >= 2;
}

export function orderMatchesSearch(order, query) {
  const q = normalizeOrderSearch(query).toLowerCase();
  if (!q) return true;
  const phoneDigits = q.replace(/\D/g, "");
  const fields = [
    String(order.order_number ?? ""),
    order.customer_name,
    order.customer_phone,
    order.customer_society,
    order.block_house_no,
    order.address_notes,
  ];
  const blob = fields
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  if (blob.includes(q)) return true;
  if (phoneDigits.length >= 4) {
    const phone = String(order.customer_phone || "").replace(/\D/g, "");
    if (phone.includes(phoneDigits)) return true;
  }
  if (/^\d+$/.test(q)) {
    const num = String(order.order_number ?? "");
    if (num === q || num.includes(q)) return true;
  }
  return false;
}
